// extracted by mini-css-extract-plugin
export default {"SingleElement":"NumericField_SingleElement__pXSHX"};